import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconCheckCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#00C853",
		fillRule: "evenodd",
		d: "M10 18.333c4.602 0 8.333-3.73 8.333-8.333S14.603 1.667 10 1.667 1.667 5.397 1.667 10c0 4.602 3.73 8.333 8.333 8.333zM5.795 9.415l2.387 2.351 6.022-5.933.796.784-6.818 6.716L5 10.2l.795-.784z",
		clipRule: "evenodd",
		opacity: .87
	})
});
export default SvgIconCheckCircle;
